import { render, staticRenderFns } from "./Multicheck.vue?vue&type=template&id=4bb6a765"
import script from "./Multicheck.vue?vue&type=script&lang=js"
export * from "./Multicheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports